import styled from "styled-components";
import { COLORS } from "../../../../../layout/theme";

export const Section = styled.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
`;

export const DetailHead = styled.div`
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	margin-bottom: 4px;
	padding-bottom: 24px;
	border-bottom: 1px solid #e4e6ea;
`;

export const DetailHeadLeft = styled.div`
	display: flex;
	align-items: flex-start;
	gap: 14px;
`;

export const DetailIconWrap = styled.div`
	width: 44px;
	height: 44px;
	border-radius: 12px;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	background: ${(props) => props.$bg || "#E6F1FB"};
	color: ${(props) => props.$color || "#185FA5"};
`;

export const DetailEyebrow = styled.div`
	font-size: 11px;
	font-weight: 700;
	color: #185fa5;
	text-transform: uppercase;
	letter-spacing: 0.07em;
	margin-bottom: 3px;
`;

export const DetailTitle = styled.div`
	font-size: 17px;
	font-weight: 700;
	color: #111827;
	letter-spacing: -0.02em;
	margin-bottom: 3px;
`;

export const DetailDesc = styled.div`
	font-size: 12px;
	color: #6b7280;
`;

export const SubGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 12px;

	@media only screen and (max-width: 1100px) {
		grid-template-columns: repeat(2, 1fr);
	}

	@media only screen and (max-width: 700px) {
		grid-template-columns: 1fr;
	}
`;

export const ModuleContainer = styled.div`
	border: 1px solid #e4e6ea;
	border-radius: 12px;
	padding: 18px 18px 16px;
	background: ${COLORS.White};
	display: flex;
	flex-direction: column;
	gap: 0;
	cursor: pointer;
	transition:
		border-color 0.15s,
		box-shadow 0.15s,
		transform 0.1s;

	&:hover {
		border-color: #185fa5;
		box-shadow: 0 0 0 3px rgba(24, 95, 165, 0.08);
		transform: translateY(-1px);
	}
`;

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 0;
`;

export const CardIconWrap = styled.div`
	width: 34px;
	height: 34px;
	border-radius: 9px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 13px;
	flex-shrink: 0;
	background: ${(props) => props.$bg || "#E6F1FB"};
	color: ${(props) => props.$color || "#185FA5"};
`;

export const CardTitle = styled.div`
	font-size: 13px;
	font-weight: 600;
	color: #111827;
	margin-bottom: 5px;
	line-height: 1.3;
`;

export const CardDesc = styled.div`
	font-size: 11px;
	color: #9ca3af;
	line-height: 1.5;
`;

export const CardArrow = styled.div`
	margin-top: 14px;
	font-size: 11px;
	color: #185fa5;
	font-weight: 600;
	opacity: 0;
	transition: opacity 0.15s;

	${ModuleContainer}:hover & {
		opacity: 1;
	}
`;

export const StyledUl = styled.ul`
	display: none;
`;

export const StyledLi = styled.li`
	display: none;
`;
